import axios from "axios";
import appConfig from "configs/app.config";
import ApiService from "./ApiService";

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: "/ppmd/sign-in",
    method: "post",
    data,
  });
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "/ppmd/sign-up",
    method: "post",
    data,
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: "/ppmd/sign-out",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: "/ppmd/forgot-password",
    method: "post",
    data,
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/ppmd/reset-password",
    method: "post",
    data,
  });
}

export async function apiNewSignIn(data) {
  return axios({
    url: appConfig.apiPrefix+"/ppmd/auth/token-login",
    method: "post",
    headers: { Authorization: `Bearer ${data}` },
  });
  // return ApiService.fetchData({
  //   url: "/ppmd/auth/token-login",
  //   method: "post",
  //   headers: { Authorization: `Bearer ${data}` },
  // });
}
